import { useFormCustomComponentFormListByEventIdQuery } from '@graphql/generated';
import { useToast } from '@withjoy/joykit';
import { useMemo } from 'react';

export const useGetFormsForEvent = (eventId: string) => {
  const { toast } = useToast();
  const { data, loading, error } = useFormCustomComponentFormListByEventIdQuery({
    variables: { eventId },
    skip: !eventId,
    batchMode: 'fast',
  });

  const forms = useMemo(() => {
    if (error) {
      toast('Something went wrong loading forms for this event');
      return [];
    }
    return data?.formListByEventId || [];
  }, [data?.formListByEventId, error, toast]);

  return { forms, loading };
};
